import React, { useEffect, useState } from 'react';
import { IPetPaymentSummaryProps } from './PetPaymentSummary.types';
import { useFlowData } from '@adaptis/flow-components';
import { PetType, Pets, IPet } from '../../util/common-types';
import './PetPaymentSummary.scss';

export default function PetPaymentSummary(props: IPetPaymentSummaryProps) {
  const { getData } = useFlowData();

  let pets: Pets = getData('pets');

  return (
    <div data-testid='PetPaymentSummary' className='flc_pet-payment-summary'>
      {pets &&
        pets.map((pet, index) => (
          <div key={'pet-pmnt-summmary' + index}>
            <PetSummaryForSelectedCover
              id={pet.id}
              summaryText={props.summaryText.toString()}
              coverType={pet.coverType ? pet.coverType.toString() : ''}
            />
          </div>
        ))}
    </div>
  );
}

function PetSummaryForSelectedCover(props: IPetSummaryForSelectedCoverProps) {
  const { injectData } = useFlowData();

  let newSummaryText = props.summaryText.replaceAll(
    '{selected',
    '{' + props.coverType
  );

  return (
    <div className='flc_-pet-summary-per-pet'>
      {injectData(newSummaryText.toString(), 'pets', 'id', props.id)}
    </div>
  );
}

interface IPetSummaryForSelectedCoverProps {
  id: string;
  summaryText: string;
  coverType: string;
}
